import { Box, Card, Grid, IconButton, Typography, useTheme } from '@mui/material'
import { showModal } from 'react-redux-modal-provider';
import EditIcon from '@mui/icons-material/Edit';
import { ButtonBasic } from '../../../components';
import FechaFunction from '../../../function/FechaFunction';
import ModalEditTareaCalendario from '../../../modals/ticket/ModalEditTareaCalendario';

const TabCuentaTareas = ({tareas, traerTareas}) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    
    const onOpenTareaEdit = (tarea) => {
        showModal(ModalEditTareaCalendario,{item: tarea, traerTareas: traerTareas})
    }
    return (
        <Grid container spacing={1}>
            { Array.isArray(tareas) && tareas?.length > 0 && (
                tareas.map((item)=>(
                    <Grid item xs={12} md={6} key={`${item?.id}tarea`}>
                        <Card
                            sx={{background: isDarkMode ? '#2d3a52' : '#fff', border: `1px solid ${isDarkMode ? '#3d4a62' : '#e0e0e0'}`, boxShadow: 3,p:2,marginTop: 2,borderRadius:4, position: 'relative' }}
                        >
                            <IconButton
                                sx={{background: isDarkMode ? '#1F2A40' : 'transparent', boxShadow: 4, position: 'absolute', top: 8, right: 8,p: 0.5}}
                                onClick={()=>onOpenTareaEdit(item)}
                            >
                                <EditIcon sx={{color: isDarkMode ? '#90caf9' : '#15294b',fontSize: 14}} />
                            </IconButton>
                            <Box sx={{display: 'flex', flexDirection: 'row',justifyContent: 'space-between'}}>
                                <Typography sx={{fontWeight: 'bold', color: isDarkMode ? '#e0e0e0' : '#000',fontSize: 15}}>{`Tarea #${item?.id || '0'} - ${item?.tipoTarea || ''}`}</Typography>
                            </Box>
                            {item?.cuentaContratoId && (
                                <Box sx={{display: 'flex', flexDirection: 'row', marginTop:1}}>
                                    <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000',fontWeight: 'bold',fontSize: 12}} component='div'>{`Servicio #${item?.cuentaContratoId}`}</Typography>
                                </Box>
                            )}
                            {!item?.cuentaContratoId && item?.contratoId && (
                                <Box sx={{display: 'flex', flexDirection: 'row', marginTop:1}}>
                                    <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000',fontWeight: 'bold',fontSize: 12}} component='div'>{`Pre-Servicio #${item?.contratoId}`}</Typography>
                                </Box>
                            )}
                            <Box sx={{display: 'flex', flexDirection: 'row', marginTop:1}}>
                                <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000',fontWeight: 'bold'}} component='div'>Dirección:<Box fontWeight='normal' display='inline'>{item?.clienteDireccion}</Box></Typography>
                            </Box>
                            {item?.clienteLatitud && item?.clienteLongitud && (
                                <Box sx={{display: 'flex', flexDirection: 'row', marginTop:1}}>
                                    <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000',fontWeight: 'bold'}} component='div'>Coordenadas:<Box fontWeight='normal' display='inline'>{`${item?.clienteLatitud}, ${item?.clienteLongitud}`}</Box></Typography>
                                </Box>
                            )}
                            {item?.fecha && (
                                <Box sx={{display: 'flex', flexDirection: 'row', marginTop:1}}>
                                    <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000',fontWeight: 'bold'}} component='div'>Fecha:<Box fontWeight='normal' display='inline'>{`${FechaFunction.format(item?.fecha,'dd-MM-yyyy')} ${item?.horaIni || ''}`}</Box></Typography>
                                </Box>
                            )}
                            <Box sx={{display: 'flex', flexDirection: 'row', marginTop:1}}>
                                <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000',fontWeight: 'bold'}} component='div'>Estado:<Box fontWeight='normal' display='inline'>{(item?.estadoTarea ==='REPROGRAMADO' && item?.observaciones === 'CRM') ? 'INSERTAR FECHA' : item?.estadoTarea }</Box></Typography>
                            </Box>
                            <Grid container spacing={2} mt={0.5} sx={{display: 'flex', justifyContent: 'center', alignItems:'center'}}>
                                <Grid item xs={12} sm={6} >
                                    <ButtonBasic
                                        textButton="Ir al calendario"
                                        variant="wk"
                                        color='nextWhite'
                                        sx={{width: 120,fontWeight: 'bold', border:1,borderColor: '#0364ff'}}
                                        onClick={()=>window?.open(`http://calendario.nubicom.com.ar/tareas/${item.id}/editar`)}
                                    />
                                </Grid>
                            </Grid>
                        </Card>
                    </Grid>
                ))
            )}
        </Grid>
    )
}

export default TabCuentaTareas